import { Link, useParams } from 'react-router-dom';
import { Briefcase, Users, TrendingUp, CheckCircle } from 'lucide-react';

const services = {
  placement: {
    title: 'Placement Consultant',
    icon: Briefcase,
    description: 'CareerQuess provides professional placement consulting services to help job seekers find the right career opportunities. We work closely with candidates to understand their skills, experience, and career goals.',
    features: [
      'Personalized career counseling and guidance',
      'Resume building and interview preparation',
      'Access to exclusive job openings from top employers',
      'End-to-end support from application to placement',
      'Industry-specific placement across 12+ sectors',
      'Follow-up support post-placement'
    ]
  },
  hr: {
    title: 'HR Consultant',
    icon: Users,
    description: 'Our HR consulting services help organizations build strong teams, streamline their hiring processes, and improve employee retention. We provide strategic HR solutions tailored to your business needs.',
    features: [
      'Recruitment process outsourcing (RPO)',
      'HR policy development and implementation',
      'Employee engagement and retention strategies',
      'Performance management systems',
      'Compensation and benefits benchmarking',
      'Workforce planning and analytics'
    ]
  },
  manpower: {
    title: 'Manpower Recruitment',
    icon: TrendingUp,
    description: 'We offer end-to-end manpower recruitment solutions across industries. Whether you need permanent employees, contract staff, or project-based teams, CareerQuess has you covered.',
    features: [
      'Permanent staffing solutions',
      'Contract and temporary staffing',
      'Bulk hiring and campus recruitment',
      'Executive search and headhunting',
      'Industry-specific talent acquisition',
      'Pan-India recruitment network'
    ]
  }
};

export default function Services() {
  const { type } = useParams();
  const service = services[type] || services.placement;
  const Icon = service.icon;

  return (
    <>
      <div className="page-header">
        <h1>{service.title}</h1>
        <p>Professional recruitment services tailored to your needs</p>
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <Link to="/">Our Services</Link> / <span>{service.title}</span>
        </div>
      </div>
      <div className="about-content">
        <div className="about-grid">
          <div className="about-text">
            <h2>{service.title}</h2>
            <p>{service.description}</p>
            <div style={{ marginTop: 24 }}>
              {service.features.map((f, i) => (
                <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 12 }}>
                  <CheckCircle size={20} color="#10b981" style={{ flexShrink: 0, marginTop: 2 }} />
                  <span style={{ color: '#475569' }}>{f}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="about-image">
            <Icon size={120} color="#2563eb" strokeWidth={1} />
          </div>
        </div>
        <div style={{ textAlign: 'center', marginTop: 40 }}>
          <Link to="/contact" className="btn-apply" style={{ padding: '16px 48px', fontSize: '1.05rem' }}>Get in Touch</Link>
        </div>
      </div>
    </>
  );
}
